import { render, staticRenderFns } from "./GrayCard.vue?vue&type=template&id=76e2680d&scoped=true"
var script = {}
import style0 from "./GrayCard.vue?vue&type=style&index=0&id=76e2680d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e2680d",
  null
  
)

export default component.exports